/* eslint-disable no-console */
import axios, {isAxiosError} from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

export interface DataLineageRequestOptions {
  signal?: AbortSignal;
}

const dataLineage = async (
  year: string,
  options?: DataLineageRequestOptions
): Promise<unknown> => {
  const token = useUserStore.getState().userToken;
  const companyID = useCompanyStore.getState().companyId;

  try {
    const response = await axios.request({
      method: CRUDMethods.GET,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.dataLineage}/${companyID}/${year}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      signal: options?.signal
    });

    return response.data.data;
  } catch (err) {
    if (isAxiosError(err) && err.code === 'ERR_CANCELED') {
      throw err;
    }
    console.log('err:', err);
  }
};

export default dataLineage;
